module.exports = __webpack_public_path__ + "static/media/16-16.371f94c1.mp3";